import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as constants from "./constants";

interface IState extends IDefaultState<any, any, any> {
  [constants.TASK_TYPE_SURVEYS]: any[],
  [constants.TASK_TYPE_SURVEYS_LOADING]: boolean;
}


const initialState:IState = {
  ...defaultInitialState,
  [constants.TASK_TYPE_SURVEYS]: [],
  [constants.TASK_TYPE_SURVEYS_LOADING]: false,
};
const reducers = {
  ...defaultReducers,
  setTaskSurveys: (state:IState, action:PayloadAction<any[]>) => {
    state[constants.TASK_TYPE_SURVEYS] = action.payload;
  },
  setTaskSurveysLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.TASK_TYPE_SURVEYS_LOADING] = action.payload;
  },
  clearTaskSurveys: (state:IState) => {
    state[constants.TASK_TYPE_SURVEYS] = [];
  }
};

export const taskTypesSlice = createSlice({
  name: "taskTypes",
  initialState,
  reducers,
});

